import { render, staticRenderFns } from "./TenantCreate.vue?vue&type=template&id=06b434be&"
import script from "./TenantCreate.vue?vue&type=script&lang=js&"
export * from "./TenantCreate.vue?vue&type=script&lang=js&"
import style0 from "./TenantCreate.vue?vue&type=style&index=0&id=06b434be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports